/* header-toggle.js
   - Hace el header transparente solo en la home (al cargar)
   - Al hacer scroll (> threshold) vuelve al header sólido
   - En páginas internas siempre header sólido
   - Añade/quita clase en main#main-content para el offset
*/

(function () {
  // CONFIGURACION (ajusta si quieres)
  var SCROLL_THRESHOLD = 50; // px para considerar "scrolled"
  var HEADER_SELECTOR = '.header-wrapper';
  var MAIN_SELECTOR = 'main#main-content';

  // detecta si estamos en la portada -> adaptamos: pathname === '/' o body con clase template-index
  function isHome() {
    try {
      var p = window.location.pathname.replace(/\/+$/, '');
      if (p === '' || p === '/') return true;
      if (document && document.body && document.body.classList.contains('template-index')) return true;
    } catch (e) {}
    return false;
  }

  function applyOffset() {
    var main = document.querySelector(MAIN_SELECTOR);
    var header = document.querySelector(HEADER_SELECTOR);
    if (!main || !header) return;
    // calcula altura real del header si quieres mayor precisión:
    var h = Math.ceil(header.getBoundingClientRect().height);
    document.documentElement.style.setProperty('--header-height', h + 'px');
    main.classList.add('header-offset-applied');
  }

  function removeOffset() {
    var main = document.querySelector(MAIN_SELECTOR);
    if (!main) return;
    main.classList.remove('header-offset-applied');
  }

  function setHeaderTransparent() {
    var header = document.querySelector(HEADER_SELECTOR);
    if (!header) return;
    header.classList.add('header--transparent');
    header.classList.remove('header--scrolled', 'header--solid');
    applyOffset();
  }

  function setHeaderSolid() {
    var header = document.querySelector(HEADER_SELECTOR);
    if (!header) return;
    header.classList.remove('header--transparent');
    header.classList.add('header--scrolled', 'header--solid');
    // en estado sólido, el header ya ocupa su espacio normal; quitamos offset si resulta mejor
    removeOffset();
  }

  function onScrollCheck() {
    var header = document.querySelector(HEADER_SELECTOR);
    if (!header) return;
    if (window.scrollY > SCROLL_THRESHOLD) {
      setHeaderSolid();
    } else {
      // sólo hacemos transparente cuando estamos en home
      if (isHome()) {
        setHeaderTransparent();
      } else {
        setHeaderSolid();
      }
    }
  }

  // Inicialización en carga
  function initHeaderBehavior() {
    // Si no hay header, salimos
    var header = document.querySelector(HEADER_SELECTOR);
    if (!header) return;

    if (isHome()) {
      // Home: transparente inicialmente
      setHeaderTransparent();
      // escucha scroll para volver a sólido
      window.addEventListener('scroll', onScrollCheck, {passive: true});
      // recalcula offset al redimensionar
      window.addEventListener('resize', applyOffset);
    } else {
      // otras páginas: sólido
      setHeaderSolid();
    }
  }

  // Re-aplica comportamiento en eventos de navegación SPA/comunes de themes
  function attachNavigationListeners() {
    var events = ['DOMContentLoaded', 'load', 'popstate', 'pageshow', 'pagehide'];
    events.forEach(function (ev) {
      window.addEventListener(ev, function () {
        // Pequeño timeout para dejar que el DOM se estabilice en navegaciones SPA
        setTimeout(initHeaderBehavior, 50);
      });
    });

    // Algunos themes usan turbo/partial navigation. Escuchamos nombres comunes.
    ['turbo:load', 'turbolinks:load', 'pjax:complete', 'shopify:section:load'].forEach(function (evt) {
      window.addEventListener(evt, function () {
        setTimeout(initHeaderBehavior, 50);
      });
    });
  }

  // Ejecuta
  attachNavigationListeners();
  // init en ejecución inmediata por si ya cargó
  setTimeout(initHeaderBehavior, 50);

})();
